import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Link } from "react-router-dom";
import "./jobBank.scss";
import useInputForm from "../../components/CustonHooks/FormHook";
import CreatableSelect from 'react-select/creatable';
import { ValidacionEmail } from "../../utils/ValidacionMail"
import Swal from "sweetalert2";
import { FormEditJob } from "./FormEditJob";
import { FormEditSectionJob } from "./FormEditSectionJob";



export function EditJob(props) {
  const [datos, setDatos] = useState({
    title: "",
    categoria: [],
    ubicacion: "",
    location: "",
    titleCompany: "",
    imagen: null,
    infoSalarial: "",
    descripcion: "",
    phoneNumber: "",
    mail: "",
  });
  const [viewForm, setViewForm] = useState("1");
  const [job, setJob] = useState({});
  let { id } = useParams();

  const toggleView = (sec) => {
    //if (viewForm == 2 && sec == 3) subirForm();
    if (viewForm !== sec) setViewForm(sec);
  };

  return (
    <div className="wrapper_reg_services">
      <div className="content_services">
        <Link to="/job-bank" className="goback trans">
          <span className="ml-1">Ir a Bolsa de trabajo</span>
        </Link>
        <h2 className="text fnt_medium text-center mt-3">Edición de empleo</h2>
        <p className="paragraph text-center">
          Llena el siguiente formulario con los datos para poder continuar con la edición de la vacante.
        </p>
        <div className="wrapper_form">
          {
          {
            1: (<FormEditJob
                  id={id}
                  datos={datos}
                  setDatos={setDatos}
                  toggleView={() => toggleView("2")} //sig
                  setJob={setJob}
                  job={job}
              />),
            2: (<FormEditSectionJob
                  toggleView={() => toggleView("1")}
                  job={job}
                  id={id}
                />)
            }[viewForm]
          }
        </div>
      </div>
    </div>
  );
}
